import dayjs from "dayjs";
import { observer } from "mobx-react-lite";
import { useEffect } from "react";
import { candidateAPI } from "../api/candidate";
import { withWSErrorContainer } from "../error/withWSErrorContainer";
import { useStorageBackedState } from "../utils/useStorageBackedState";
import { useNotificationPermission } from "./useNotificationPermission";
import { usePushNotificationsConditionally } from "./usePushNotificationsConditionally";
import { AddPwaTokenParameters } from "../api/candidate/addPwaToken";

// put into its own component to avoid re-rendering the whole app when the notification permission changes
export const PushNotificationsProvider = withWSErrorContainer(
  observer(() => {
    const notificationPermission = useNotificationPermission();
    const { fcmToken, fcmTokenInitialized } =
      usePushNotificationsConditionally();

    ////// Sync fcmToken to backend //////

    const parameters: AddPwaTokenParameters = {
      deviceId: navigator.userAgent,
      expirationDate: roundedExpirationDate(), // fcm tokens dont have an expiration date
      fcmToken: fcmToken,
      pushDisabled: notificationPermission !== "granted",
    };

    // stringify is fast enough for small objects and makes the logic easy
    const _parameters = JSON.stringify(parameters);

    const [_parametersPrev, setParametersPrev] = useStorageBackedState(
      "addPwaTokenParametersPrev",
      _parameters
    );

    // the date rounding makes _parameters change every month only, unless any of the other parameters change
    // effectively throttling the api call
    useEffect(() => {
      if (fcmTokenInitialized && _parametersPrev !== _parameters) {
        candidateAPI.addPwaToken(parameters).then((response) => {
          if (response.ok) {
            setParametersPrev(_parameters);
          }
        });
      }
    }, [_parameters]);

    return null;
  })
);

function roundedExpirationDate() {
  return dayjs(new Date()).add(1, "year").startOf("month").toDate();
}
